export default __webpack_public_path__ + "static/Pharmaceutical-8bbd7d9b195402d180adf60f8fb45b6e.png";